import script from "./AssessmentGovernanceCoordination.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGovernanceCoordination.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGovernanceCoordination.vue?vue&type=style&index=0&id=a127071a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a127071a"]])

export default __exports__